<ion-toolbar class="content-background" style="border-bottom:0.1em solid #00738233;">
  <ion-row  *ngIf="from=='filter'" class="toolbar-row">
    <ion-col>
      <div class="ratings-label">
        {{'QR_MANAGEMENT.FILTER'|translate}}
      </div>
    </ion-col>
    <ion-col size="2">
      <div class="close-div">
        <ion-icon (click)="closeDismiss()" class="close-icon-size" name="close-outline"></ion-icon>
      </div>
    </ion-col>
  </ion-row>
  <ion-row  *ngIf="from=='sort'" class="toolbar-row">
    <ion-col>
      <div class="ratings-label">
        {{'RATING.SORT'|translate}}
      </div>
    </ion-col>
    <ion-col size="2">
      <div class="close-div">
        <ion-icon (click)="closeDismiss()" class="close-icon-size" name="close-outline"></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-toolbar>

<ion-content class="content-background" scroll-y="false">
  <div style="margin-top:0px;overflow: scroll;
      height: 230px;padding-bottom: 50px;" *ngIf="from=='sort'">
    <ion-list style="padding-bottom:40px;" class="toolbar-row"  lines="none">
      <ion-item lines="none" *ngIf="ratingSubmitted=='rating'" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Zones')">{{'AREA_MANAGEMENT.ZONES_ASSIGNED'|translate}}</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
      <ion-item lines="none" *ngIf="ratingSubmitted=='area' && service?.appData?.userInfo?.h_and_s=='Yes'" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Ratings')">{{'AREA_MANAGEMENT.RATINGS'|translate}}</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
      <ion-item lines="none" *ngIf="ratingSubmitted=='area' && service?.appData?.userInfo?.h_and_s=='No'" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Zones')">{{'AREA_MANAGEMENT.ZONES_ASSIGNED'|translate}}</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
      <ion-item *ngIf="ratingSubmitted=='area' || ratingSubmitted=='site-and-month'" lines="none" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Months')">{{'RATING.MONTHS'|translate}}</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
      <ion-item *ngIf="ratingSubmitted=='rating'" lines="none" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Dates')">Dates</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
      <ion-item *ngIf="ratingSubmitted=='site-and-month'" lines="none" class="ion-activatable ripple-parent">
        <ion-label style="color:#363636;font-size:14px;" (click)="dismiss('Sites')">{{'TREASURE_HUNT.SITES'|translate}}</ion-label>
        <ion-ripple-effect></ion-ripple-effect>
      </ion-item>
    </ion-list>
  </div>
  <ion-grid   *ngIf="from=='filter'" class="first-grid">
    <div (click)="labelClick('area')" *ngIf="ratingSubmitted=='area' && service?.appData?.userInfo?.h_and_s=='Yes'" [ngClass]="{'selected_label':segmentName=='area', 
    'unselected_label' : segmentName!='area' }">
      {{'AREA_MANAGEMENT.AREA'|translate}}
    </div>
    <div *ngIf="showZone" (click)="labelClick('zone')" [ngClass]="{'selected_label':segmentName=='zone', 
    'unselected_label' : segmentName!='zone' }">
      {{'BOG_TOUR.LBL_ZONE'|translate}}
    </div>
    <div (click)="labelClick('date')" [ngClass]="{'selected_label':segmentName=='date', 
    'unselected_label' : segmentName!='date' }">
    {{'RATING.ZONE_TYPE'|translate}}
    </div>
  </ion-grid>
  <ion-grid scroll-y="true" *ngIf="from=='filter'" class="second-grid">
    <div *ngIf="segmentName=='area' && service?.appData?.userInfo?.h_and_s=='Yes'">
      <form [formGroup]="searchForm">
        <formly-form [model]="model" [fields]="fields" [options]="options" [form]="searchForm"></formly-form>
      </form>
      <div style="margin-top:-20px;overflow: scroll;
      height: 240px;padding-bottom: 30px;">
        <div *ngFor="let item of areaNameList;let i=index"  class="area-list">
          <ion-icon *ngIf="item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;height:18px;width:18px;background:#007382;color:#FFFFFF;" name="checkmark-outline"></ion-icon>
          <ion-icon *ngIf="!item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;color:#007382;height:18px;width:18px;" name="square-outline"></ion-icon>
          <ion-label [ngClass]="{'select-area':item.selected, 
          'unselect-area' : !item.selected }">{{item.full_name}}</ion-label>
        </div>
      </div>
    </div>

    <div *ngIf="segmentName=='zone' && ratingSubmitted=='area' && service?.appData?.userInfo?.h_and_s=='No'">
      <form [formGroup]="zoneForm">
        <formly-form [model]="model" [fields]="zoneField" [options]="options" [form]="zoneForm"></formly-form>
      </form>

      <div style="margin-top:-20px;overflow: scroll;
      height: 240px;padding-bottom: 30px;">

        <div *ngFor="let item of areaZoneList;let i=index"  class="area-list">
                <!-- <div>areaZoneList: {{item}} </div>  -->

          <ion-icon *ngIf="item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;height:18px;width:18px;background:#007382;color:#FFFFFF;" name="checkmark-outline"></ion-icon>
          <ion-icon *ngIf="!item.selected" (click)="selectAreaName(item,i)" style="border-radius:4px;color:#007382;height:18px;width:18px;" name="square-outline"></ion-icon>
          <ion-label [ngClass]="{'select-area':item.selected, 
          'unselect-area' :!item.selected }"> 1 {{item.name}}</ion-label>
        </div>
      </div>
    </div>

    <div *ngIf="segmentName=='zone' && ratingSubmitted=='rating'">
      <!-- <h2>  ratingZoneList:     {{ratingZoneList}}</h2>  -->
      <form [formGroup]="zoneForm">
        <formly-form [model]="model" [fields]="zoneField" [options]="options" [form]="zoneForm"></formly-form>
      </form>

      <div style="margin-top:-20px;overflow: scroll;
      height: 240px;padding-bottom: 30px;">

        <div *ngFor="let item of ratingZoneList;let i=index"  class="area-list">
          <ion-icon *ngIf="item.selected" (click)="selectRatingName(item,i)" style="border-radius:4px;height:18px;width:18px;background:#007382;color:#FFFFFF;" name="checkmark-outline"></ion-icon>
          <ion-icon *ngIf="!item.selected" (click)="selectRatingName(item,i)" style="border-radius:4px;color:#007382;height:18px;width:18px;" name="square-outline"></ion-icon>
          <ion-label [ngClass]="{'select-area':item.selected, 
          'unselect-area' :!item.selected }">2 {{item.name}}</ion-label>
        </div>
      </div>
    </div>

    <div *ngIf="segmentName=='date'">
      <form [formGroup]="dateForm" class="date">
        <formly-form [model]="model" [fields]="dateField" [options]="options" [form]="dateForm"></formly-form>
      </form>
     
    </div>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="from=='filter'" style="background:#007382;">
  <ion-row>
    <ion-col style="padding: 14px;" (click)="clearFilter()" class="ion-activatable ripple-parent ion-text-center ion-align-self-center">
      <ion-label style="color:#FFFFFF;font-size:16px;">{{'RATING.CLEAR_FILTER'|translate}}</ion-label>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
    <ion-col (click)="dismiss('filter')" style="padding:14px;" class="ion-activatable ripple-parent ion-text-center ion-align-self-center">
      <ion-label style="color:#FFFFFF;font-size:16px;font-weight:600;">{{"RATING.APPLY"|translate}}</ion-label>
      <ion-ripple-effect></ion-ripple-effect>
    </ion-col>
  </ion-row>
</ion-footer>
